{
  "R": [0, 255],
  "G": [0, 0],
  "B": [255, 255],
  "A": [0, 128],
  "I": [0, 255]
}
